module.exports = __webpack_public_path__ + "static/media/01-desktop.fba2f9db.png";